<template>
  <div class="map-type" @click="onClick" :class="type"></div>
</template>

<script>
export default {
  name: "MapTypes",
  props: {
    map: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      type: "img",
    };
  },
  methods: {
    onClick() {
      this.type = this.type === "img" ? "vector" : "img";
      if (this.map.getSource("cvawUrl")) {
        this.map.removeLayer("cvawUrl");
        this.map.removeSource("cvawUrl");
      }
      if (this.type === "vector") {
        const cvawUrl =
          "https://t3.tianditu.gov.cn/cia_w/wmts?" +
          "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&" +
          "TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=04f65c2ff30922b1f615f42c80db4ebe";

        this.addTitleLayer(this.map, [cvawUrl], "cvawUrl", "cvawUrl",512);
      }
      this.$emit("on-click", this.type);
    },
    addTitleLayer(map, url, sourceId, layerId, tileSize = 256) {
      map.addSource(sourceId, {
        type: "raster",
        tiles: url,
        tileSize: tileSize,
        maxzoom: 30,
      });

      map.addLayer({
        id: layerId,
        type: "raster",
        source: sourceId,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.map-type {
  width: 86px;
  border: 1px solid #111;
  border-radius: 4px;
  overflow: hidden;
  height: 60px;
  position: absolute;
  bottom: 110px;
  left: 30%;
  cursor: pointer;
  z-index: 10;
  background: url("../images/maptype.png") no-repeat center;
  background-size: 100% auto;
  &:hover {
    border-color: #0152d9;
  }

  &.img {
    background-position: 0 -180px;
  }
  &.vector {
    background-position: 0 0;
  }
}
</style>
